import { DatabaseId } from "@syla/shared/types/helpers/Id";
import { CreateManualSubscriptionRequestBody } from "@syla/shared/types/requests/CreateManualSubscriptionRequest";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function createManualSubscription(
  accountId: DatabaseId,
  body: CreateManualSubscriptionRequestBody,
): Promise<void> {
  try {
    await axios.post(
      `/accounts/${accountId}/subscriptions/create-manual-subscription`,
      body,
    );
  } catch (error) {
    throwSylaApiError(error);
  }
}
